import script from "./ModeratorNewsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ModeratorNewsForm.vue?vue&type=script&setup=true&lang=js"

import "./ModeratorNewsForm.vue?vue&type=style&index=0&id=b4f53ea2&lang=css"
import "./ModeratorNewsForm.vue?vue&type=style&index=1&id=b4f53ea2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4f53ea2"]])

export default __exports__